import { Empty, Flex, Skeleton } from 'antd';
import type { JSX } from 'react';
import { useUserOrganizations } from '../../hooks/useOrganizations';
import { useCurrentUser } from '../../hooks/useCurrentUser';
import { OrganizationRegistrationProcessComponent } from '../OrganizationRegistrationProcessComponent';

const OrganizationListComponent = (): JSX.Element => {
  const userOrganizations = useUserOrganizations(useCurrentUser().id);

  if (userOrganizations.isLoading) {
    return <Skeleton active />;
  }

  if (!userOrganizations.data?.length) {
    return <Empty />;
  }

  return (
    <Flex vertical gap={16}>
      {userOrganizations.data.map((organization) => (
        <OrganizationRegistrationProcessComponent
          key={organization.id}
          userOrganization={organization}
        />
      ))}
    </Flex>
  );
};
export default OrganizationListComponent;
